<template>
  <v-form ref="form" id="contNewTag" class="p-4 border-radius-top-t">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="bg-primary d-flex align-center py-4 px-5 border-radius-top-t">
      <v-btn icon color="transparent" @click="$emit('tagComments', true)">
        <v-icon color="white">mdi-arrow-left</v-icon>
      </v-btn>
      <h3 class="text-complementary-color">Nueva etiqueta</h3>
    </div>
    <div class="d-flex flex-column pa-5">
      <v-btn
        class="ml-auto button-tertiary"
        max-width="fit-content"
        @click="dialog = true"
      >
        <span class="">Ayuda</span>
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
      <span class="text-body-2 font-weight-bold my-2">Clave</span>
      <v-text-field
        class="customInpunt"
        v-model="data.Tag"
        :rules="requiredRules"
        single-line
        solo
      ></v-text-field>
      <span class="text-body-2 font-weight-bold my-2">Valor</span>
      <div
        class="contInputValue"
        v-for="(item, index) in data.Values"
        :key="index"
      >
        <v-text-field
          class="customInpunt"
          v-model="data.Values[index]"
          :rules="requiredRules"
          single-line
          solo
        ></v-text-field>
        <v-btn icon v-if="index > 0" @click="delValue(index)">
          <v-icon color="#2e2e2d">mdi-close-circle-outline</v-icon>
        </v-btn>
        <v-btn
          icon
          v-if="data.Values.length == index + 1 && data.Values[index]"
          @click="addValue()"
        >
          <v-icon color="#27e96a">mdi-plus-circle-outline</v-icon>
        </v-btn>
      </div>
      <div class="contBtn">
        <v-btn @click="$emit('tagComments', true)" class="button-primary"
          >Cancelar</v-btn
        >
        <v-btn class="button-tertiary" @click="saveData()">Guardar</v-btn>
      </div>
    </div>
    <Help v-if="dialog" :show="dialog" @closeDialog="dialog = false"></Help>
    <v-snackbar v-model="showError" color="red" :timeout="5000" max-width="100">
      {{ textError }}
    </v-snackbar>
  </v-form>
</template>
<script>
import { mapState } from "vuex";
import Help from "@/components/tagConfigComments/help";
export default {
  components: {
    Help,
  },
  props: ["itemEdit"],
  data() {
    return {
      data: {
        Tag: "",
        Values: [""],
      },
      dialog: false,
      requiredRules: [(v) => !!v || "Campo requerido"],
      showError: false,
      textError: "",
      loading: false,
    };
  },
  mounted() {
    if (this.itemEdit) {
      this.data = this.itemEdit;
    }
  },
  computed: {
    ...mapState("tagConfigComments", ["tagList"]),
  },
  methods: {
    addValue() {
      this.data.Values.push("");
    },
    delValue(key) {
      this.data.Values.splice(key, 1);
    },
    async saveData() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const list = [...this.tagList];
        if (this.itemEdit) {
          const index = list.indexOf(this.itemEdit);
          list[index] = this.data;
        } else {
          list.push(this.data);
        }
        try {
          this.$store.commit("tagConfigComments/SET_TAG_COMMENTS", list);
          await this.$store.dispatch(
            "tagConfigComments/updateTagComments",
            list
          );
          this.$emit("tagComments", true);
        } catch (error) {
          this.$store.commit("tagConfigComments/SET_TAG_COMMENTS", []);
          this.textError = error;
          this.showError = true;
        }
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../styles/global.scss";
.v-application .error--text {
  color: $primary-color !important;
  caret-color: $primary-color !important;
}
#contNewTag {
  width: 100%;
  background: #ffffff;

  .contBtn {
    border-top: 1px solid #e3e4e6;
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 0 0;
    padding: 20px 0 0 0;
    gap: 20px;
  }
  .contInputValue {
    display: flex;
    align-items: flex-start;
    animation: fade 1s ease-in-out;
  }
  .v-input {
    &.customInpunt {
      max-width: 300px;
      .v-input__control {
        min-height: 35px;
        .v-input__slot {
          box-shadow: none;
          border: 1px solid rgba(0, 0, 0, 0.12);
        }
      }
    }
  }
}
</style>
